<template>
  <a
    :class="{dark: isDark, [size]: size}"
    class="logo"
    href="https://simplecast.com"
    target="simplecast"
    title="Simplecast Homepage"
  >
    <IconLogo />
  </a>
</template>

<script>
import IconLogo from '../assets/svg/sc-logo.svg'
import Store from '../store'

export default {
  components: { IconLogo },
  data () {
    return {
      store: Store
    }
  },
  computed: {
    isDark () { return this.store.state.isDark },
    size () { return this.store.state.size }
  }
}
</script>

<style lang="scss">
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';

.sc-logo {
  g {
    fill: $black-800;
  }
}
.dark .sc-logo {
  g {
    fill: $white-000;
  }
}
</style>

<style lang="scss" scoped>
@import '../assets/styles/breakpoints.scss';

.logo {
  opacity: .1;
  position: absolute;
  z-index: 100;

  &.dark {
    opacity: .2;
  }

  svg {
    height: 100%;
    width: 100%;
  }
}
.size-mini {
  display: none;
}
</style>
